import './Value.css';

const Value = () => {
  return (
    <div className="values-section">
      <h2 className="values-title">Our Values</h2>
      <p className="values-description">
        Integrity, respect, open access, and a commitment to developing capable
        professionals who drive progress in healthcare and society.
      </p>
    </div>
  );
};

export default Value;
